"use client";

import { useGetBlogs } from "@/hooks/main-hook";
import { BlogTypes } from "@/types/main-types";
import { useLocale } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import { BlogSkeleton } from "../loading/mainLoading";

export default function Blog({ limit = 6 }: { limit?: number }) {
  const locale = useLocale();
  const { data, isLoading } = useGetBlogs({ page: 1, limit });

  const blogs = data?.blogs || [];

  const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  return (
    <div className=" mt-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {isLoading
          ? [...Array(4)].map((_, index) => <BlogSkeleton key={index} />)
          : blogs?.map((blog: BlogTypes) => (
              <div
                key={blog?.id}
                className="flex flex-col lg:flex-row lg:items-center gap-5 border border-gray-200 rounded-xl"
              >
                <div className="relative w-80 h-80">
                  <Image
                    src={blog.image}
                    alt={blog.title.en}
                    fill
                    priority
                    className="rounded-lg"
                  />
                </div>
                <div className="lg:w-1/2">
                  <div>
                    {/* ADD HTML ELEMENT */}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: locale === "ar" ? blog.title.ar : blog.title.en,
                      }}
                      className="mb-4"
                    />
                    {/* TRUNCATE DESCRIPTION */}
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          locale === "ar"
                            ? truncateText(blog.description.ar, 100)
                            : truncateText(blog.description.en, 100),
                      }}
                      className="text-gray-600"
                    />
                    <div className="flex justify-end mt-2">
                      <Link
                        href={`/blog/${blog.slug}`}
                        className="bg-main text-white px-4 py-2 rounded mt-4 inline-block"
                      >
                        {locale === "ar" ? "اقرأ المزيد" : "Read More"}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
      </div>

      {/* {data?.paginate.totalPages > 1 && !isHome && (
        <Paginate
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={data?.paginate?.totalPages}
        />
      )} */}
    </div>
  );
}
